import React from 'react'

const Title2 = ({tit,model}) => {
  return (
    <>
    { 
      (model === "def" && <h2 className= "mt-2 z-10 font-special text-white text-center block mb-2 text-2xl font-bold">{tit}</h2>) ||
      (model === "sb" && <h2 className= "mt-2 z-10 font-special text-preto-suave text-center block mb-2 text-2xl font-bold">{tit}</h2>) ||
      (model === "wr" && <h2 className= "mt-2 z-10 font-roboto text-white text-center block mb-2 text-2xl font-bold">{tit}</h2>) ||
      (model === "br" && <h2 className= "mt-2 z-10 font-roboto text-preto-suave text-center block mb-2 text-2xl font-bold">{tit}</h2>)
    }
    </>
  )
}

export default Title2